<template>
    <div class="font-roboto" v-if="true">
        <div v-show="!isShowDetail">
            <Breadcrumbs main="" :title="$t('lbl_EMPBE_PIG')" />
            <div class="PIG-Wrapper">
                <div class="title-wrapper w-100">
                    <span class="title">{{ $t("lbl_EMPBE_PIG") }}</span>
                    <span v-if="requiredSubmitNums > 0" class="status-summary REQUIRED">{{ $t("lbl_EMPBE_PIG_ExhInfoReqToSubmit", { noOfExhibits: requiredSubmitNums }) }}</span>

                    <a class="ml-auto btn btn-outline-primary f-right" :href="PIGUrl" target="_blank" v-bind:t_label="'EMPBE_PIG_ViewPIGUrl'">
                        <i class="fa fa-eye"></i>
                        {{ $t("lbl_EMPBE_ViewPIG") }}
                    </a>
                </div>

                <div class="content-container">
                    <div>
                        <div class="sub-title">{{ $t("lbl_EMPBE_Instruction") }}</div>
                        <div class="desc" v-html="$t('lbl_EMPBE_PIGDesc')" ></div>
                    </div>

                    <div class="photoGalleryCards">
                        <PhotoGalleryCard
                            v-for="info in photoGalleryCardInfos"
                            :key="info.cardType"
                            :cardType="info.cardType"
                            :title="info.title"
                            :deadline="info.deadline"
                            :imgDesc="info.imgDesc"
                            :imgs="info.imgs"
                            :imgHeight="info.imgHeight"
                            :imgWidth="info.imgWidth"
                            @onClickImg="onClickImg">
                        </PhotoGalleryCard>
                    </div>
                </div>

                <PIGGrid ref="PIGGrid" :res="res" @onUpdateReqNum="onUpdateReqNum" @openDetail="openDetail"></PIGGrid>
            </div>
        </div>

        <!-- Approval / embedded: same-window detail (like productInfo) -->
        <PIGDetail
            v-if="isShowDetail && tempEndProductId"
            :key="'PIGDetail_' + tempEndProductId"
            :endProductId="tempEndProductId"
            :supplierId="companyid || supplierId"
            :embedded="true"
            :submit-type="submitType"
            @close="handleHideDetail"
        />

        <!-- Normal /PIG route: nested route sidebar -->
        <PIGDetailSideBar v-if="!isApprovalMode" ref="DetailSideBar"></PIGDetailSideBar>
           
        <!--Image pop up-->
        <ImgSideBar :imgs="sideBarImgUrls" ref="sidebar"></ImgSideBar>
    </div>
</template>

<script>
import  ImgSideBar  from "./component/ImgSideBar";
import PIGGrid from "./component/Grid";
import PIGDetailSideBar from "./component/DetailSideBar.vue";
import PIGDetail from "./component/Detail.vue";
import PhotoGalleryCard from "./component/PhotoGalleryCard.vue";
import { endProductService } from '@/_services/endproduct.service';

export default{
    props: {
        supplierId: {
            type: [String, Number],
            default: null,
        },
        submitType: {
            type: String,
            default: "",
        },
    },
    components:{
        ImgSideBar,
        PIGGrid, 
        PIGDetailSideBar,
        PIGDetail,
        PhotoGalleryCard
    },

    data() {
        return {
            sideBarImgUrls: [],
            requiredSubmitNums: 0,
            isShowDetail: false,
            tempEndProductId: null,

            res: {
                endProductList: [],
                firstDisplayDeadline: "",
                realFormLockDeadline: "",
                secondDisplayDeadline: "",
            },
        };
    },

    computed: {
        user() {
            return this.$store?.state?.authentication?.user || null;
        },
        companyid() {
            const fromProp = Number(this.supplierId);
            if (!isNaN(fromProp) && fromProp > 0) {
                return fromProp;
            }
            const fromUser = Number(this.user?.empCompanyId);
            return !isNaN(fromUser) && fromUser > 0 ? fromUser : null;
        },
        isApprovalMode() {
            return (this.submitType || "").toLowerCase() === "approval";
        },
        langId() {
            return localStorage.getItem("currentLangId");
        },

        PIGUrl() {
            return `${process.env.VUE_APP_EMP_VIEW}productinnovationgallery`;
        },
        
        submittedNums() {
            return 0;
        },

        delistedNums() {
            return 0;
        },

        photoGalleryCardInfos() {
            const that = this;
            const currDate = this.$moment().startOf("day");
            const firstDeadline = this.$moment(that.res.firstDisplayDeadline);
            const secondDeadline = this.$moment(that.res.secondDisplayDeadline);
            const isBeforeFirstDeadline = currDate.isSameOrBefore(firstDeadline);
            const isBeforeSecondDeadline = currDate.isSameOrBefore(secondDeadline);
            
            const deadlineDate = isBeforeFirstDeadline
                ? {
                      DD: firstDeadline.format("DD"),
                      MMM:
                          this.langId === "1252"
                              ? firstDeadline.format("MMM")
                              : firstDeadline.format("MM"),
                      YYYY: firstDeadline.format("YYYY"),
                  }
                : isBeforeSecondDeadline
                ? {
                      DD: secondDeadline.format("DD"),
                      MMM:
                          this.langId === "1252"
                              ? secondDeadline.format("MMM")
                              : secondDeadline.format("MM"),
                      YYYY: secondDeadline.format("YYYY"),
                  }
                : {
                      DD: secondDeadline.format("DD"),
                      MMM:
                          this.langId === "1252"
                              ? secondDeadline.format("MMM")
                              : secondDeadline.format("MM"),
                      YYYY: secondDeadline.format("YYYY"),
                  };

            const ossLang = localStorage.getItem("currentLangId") == 1252
                ? 'EN'
                : localStorage.getItem("currentLangId") == 950
                ? 'TC'
                : 'SC';
            
            return [
                {
                    cardType: "offline",
                    title: this.$t("lbl_EMPBE_PIG_CPSOfflineShow"),
                    deadline: this.$t("lbl_EMPBE_PIG_DeadlineDate", deadlineDate),
                    imgDesc: this.$t("lbl_EMPBE_PIG_PIGEgInCPS"),
                    imgHeight: "60px",
                    imgs: [
                        {
                            type: "single",
                            url: "https://cdn.adsalecdn.com/EMP/Backend/Images/PIG/PIG_3.png",
                            isShowOnPanel: true,
                        },
                        {
                            type: "single",
                            url: "https://cdn.adsalecdn.com/EMP/Backend/Images/PIG/PIG_4.png",
                            isShowOnPanel: true,
                        },
                        {
                            type: "list",
                            list: [
                                "https://cdn.adsalecdn.com/EMP/Backend/Images/PIG/Sample1.png",
                                "https://cdn.adsalecdn.com/EMP/Backend/Images/PIG/Sample2.png",
                            ],
                            isShowOnPanel: false,
                        },
                        {
                            type: "single",
                            url: "https://cdn.adsalecdn.com/EMP/Backend/Images/PIG/Wall1.png",
                            isShowOnPanel: true,
                            title: this.$t("lbl_EMPBE_PIG_BasicDisplayType"),
                        },
                        {
                            type: "single",
                            url: "https://cdn.adsalecdn.com/EMP/Backend/Images/PIG/UpgradeDisplay.png",
                            isShowOnPanel: true,
                            title: this.$t("lbl_EMPBE_PIG_UpgradeDisplayType"),
                        },
                        {
                            type: "single",
                            url: "https://cdn.adsalecdn.com/EMP/Backend/Images/PIG/Wall2.png",
                            isShowOnPanel: true,
                            title: this.$t("lbl_EMPBE_PIG_PremiumDisplayType"),
                        },
                        {
                            type: "single",
                            url: "https://cdn.adsalecdn.com/EMP/Backend/Images/PIG/Wall3.png",
                            isShowOnPanel: true,
                        },
                    ],
                },
                {
                    cardType: "online",
                    title: this.$t("lbl_EMPBE_PIG_EMPPromotion"),
                    deadline: "",
                    imgDesc: this.$t("lbl_EMPBE_PIG_PIGEgInEMP"),
                    imgHeight: "60px",
                    imgs: [
                        {
                            type: "single",
                            url: `https://cdn.adsalecdn.com/EMP/Backend/Images/PIG/PigPageHome_${ossLang}.png`,
                            isShowOnPanel: true,
                        },
                        {
                            type: "single",
                            url: `https://cdn.adsalecdn.com/EMP/Backend/Images/PIG/PigPageDisplaySection_${ossLang}.png`,
                            isShowOnPanel: true,
                        },
                        {
                            type: "single",
                            url: `https://cdn.adsalecdn.com/EMP/Backend/Images/PIG/PigPageProduct_${ossLang}.png`,
                            isShowOnPanel: true,
                        },
                    ],
                },
            ];
        }
    },

    mounted() {
        this.init();
    },

    methods: {
        init() {
            // Get Data From server
            this.GetPIGData();
        },

        GetPIGData(){
            var that = this;
            var companyId=that.companyid||this.supplierId;
            if (!companyId) {
                return;
            }
            if (that.$refs["PIGGrid"]) {
                that.$refs["PIGGrid"].setIsLoading(true);
            }
            // supplierId from parent (approval) takes priority; otherwise use login company
            endProductService.GetListByCompanyId(companyId).then((res)=>{
                if(res.isSuccessful){
                    that.res = res.data;
                }
            }).finally(() => {
                that.$refs["PIGGrid"]?.setIsLoading(false);
            })
        },

        onClickImg(imgs) {
            this.sideBarImgUrls = imgs;
        },

        onUpdateReqNum(newValue) {
            this.requiredSubmitNums = newValue;
        },

        openDetail(pigId) {
            // Approval / embedded: same-window swap like productInfo (supplierProductInfo)
            if (this.isApprovalMode) {
                this.isShowDetail = true;
                this.tempEndProductId = pigId;
                return;
            }

            this.$router.push({
                name: "PIGDetail",
                params: { id: pigId },
            });
        },

        handleHideDetail() {
            this.isShowDetail = false;
            this.tempEndProductId = null;
            this.$nextTick(() => {
                this.GetPIGData();
            });
        },
    },
}
</script>

<style lang="scss">
  @import "./style/default"; 
</style>
